import React from "react";
import { Stack, Typography } from "@mui/material";
import { HubCardStack } from "../../components";

const ResetPasswordError = () => {
  return (
    <HubCardStack
      gap="5px"
      sx={{
        borderLeft: "25px solid",
        borderColor: "hubColors.redMain",
      }}
    >
      <Typography variant="boldCaption">Unable to Reset Password</Typography>
      <Typography variant="caption">
        The token is invalid, has expired, or already been used. Please contact
        an admin for more information.
      </Typography>
    </HubCardStack>
  );
};

export default ResetPasswordError;
